define('home/views/TopicCoverView',[
    'backbone-marionette',
    'home/utils/backboneUtils',

    'home/templates/topicCover',
], function (
    Marionette,
    backboneUtils,

    topicCoverTemplate
) {
    'use strict';

    var TopicCoverView = Marionette.ItemView.extend({
        className: 'cover-body',
        template: topicCoverTemplate,

        getMetaAttrs: function () {
            return backboneUtils.getPromiseFor(this.model, 'name')
                .then(function (topicName) {
                    return topicName.charAt(0).toUpperCase() +
                        topicName.slice(1);
                });
        },
    }, {
        /**
         * Used to chose the correct model for this view.
         * If the given model has a related topic, returns
         * that topic. Otherwise assumes that the given model
         * is a topic and passes it through.
         *
         * @param  {Model} model - A model that is a topic or has
         *                         a related topic.
         * @returns {Topic}       - A topic model, as this view expects
         *                         to be initialized with.
         */
        getModel: function (model) {
            return model.topic || model;
        },
    });

    return TopicCoverView;
});

